export default __webpack_public_path__ + "static/media/2930 spice rack E top.4e8e8558.png";